// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrimaryButton_primaryButton__g83qt {
  color: white;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 22px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  font-size: var(--font-boton);
  min-width: 120px;
  position: relative;
}
.PrimaryButton_primaryButton__g83qt:hover:not(:disabled) {
  transform: translateY(-1px);
}
.PrimaryButton_primaryButton__g83qt:disabled {
  background-color: #b6b6b6 !important;
  cursor: not-allowed !important;
  transform: none;
}

.PrimaryButton_primary__sfZbk {
  background-color: var(--color-primario);
}
.PrimaryButton_primary__sfZbk:hover:not(:disabled) {
  background-color: var(--color-primario-dark);
}

.PrimaryButton_secondPrimary__dlsOi {
  color: var(--color-primario-dark);
  font-size: var(--font-boton);
  font-weight: 600;
  border-radius: 6px;
  background-color: var(--color-primario-claro-200);
  border: 1px solid var(--color-primario-claro);
  padding: 5px 22px;
  transition: background-color 0.2s ease;
}
.PrimaryButton_secondPrimary__dlsOi.PrimaryButton_active__US9aI {
  background-color: var(--color-primario-claro);
}
.PrimaryButton_secondPrimary__dlsOi:hover:not(:disabled) {
  background-color: var(--color-primario-claro);
}
.PrimaryButton_secondPrimary__dlsOi:disabled {
  background-color: #e0e0e0;
  color: #888;
  border-color: #d0d0d0;
  cursor: not-allowed !important;
}

.PrimaryButton_spinner__iQeBY {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: PrimaryButton_spin__PpNHN 0.8s linear infinite;
}

@keyframes PrimaryButton_spin__PpNHN {
  to {
    transform: rotate(360deg);
  }
}
.PrimaryButton_loading__d8ZQq {
  pointer-events: none;
  opacity: 0.8;
  transform: none;
}
.PrimaryButton_loading__d8ZQq .PrimaryButton_spinner__iQeBY {
  position: absolute;
}

.PrimaryButton_contentHidden__SBrp6 {
  opacity: 0;
}

.PrimaryButton_cancel__RhE8X {
  color: var(--color-cancelar-dark);
  font-size: var(--font-boton);
  font-weight: 600;
  border-radius: 6px;
  background-color: var(--color-cancelar-claro);
  border: 1px solid var(--color-cancelar);
  padding: 5px 22px;
  transition: background-color 0.2s ease;
}
.PrimaryButton_cancel__RhE8X.PrimaryButton_active__US9aI {
  background-color: var(--color-cancelar-claro);
}
.PrimaryButton_cancel__RhE8X:hover:not(:disabled) {
  background-color: var(--color-cancelar);
  transform: translateY(0) !important;
}
.PrimaryButton_cancel__RhE8X:disabled {
  background-color: #e0e0e0;
  color: #888;
  border-color: #d0d0d0;
}

@media (max-width: 480px) {
  .PrimaryButton_primaryButton__g83qt {
    width: 100%;
    min-width: auto;
    padding: 10px 16px;
  }
}
.PrimaryButton_danger__gj81g {
  color: white;
  font-size: var(--font-boton);
  font-weight: 600;
  border-radius: 6px;
  background-color: var(--color-danger);
  border: 1px solid var(--color-danger-dark);
  padding: 5px 22px;
  transition: background-color 0.2s ease, transform 0.1s ease;
}
.PrimaryButton_danger__gj81g:hover:not(:disabled) {
  background-color: var(--color-danger-dark) !important;
  transform: translateY(0) !important;
}
.PrimaryButton_danger__gj81g.PrimaryButton_active__US9aI {
  background-color: var(--color-danger-dark);
}
.PrimaryButton_danger__gj81g:disabled {
  background-color: #e0e0e0;
  color: #888;
  border-color: #d0d0d0;
  cursor: not-allowed !important;
}`, "",{"version":3,"sources":["webpack://./src/components/PrimaryButton/PrimaryButton.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,2DAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,2BAAA;AACJ;AAEE;EACE,oCAAA;EACA,8BAAA;EACA,eAAA;AAAJ;;AAIA;EACE,uCAAA;AADF;AAGE;EACE,4CAAA;AADJ;;AAKA;EACE,iCAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,6CAAA;EACA,iBAAA;EACA,sCAAA;AAFF;AAIE;EACE,6CAAA;AAFJ;AAKE;EACE,6CAAA;AAHJ;AAME;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,uBAAA;EACA,kBAAA;EACA,yDAAA;AALF;;AAQA;EACE;IACE,yBAAA;EALF;AACF;AAQA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;AANF;AASE;EACE,kBAAA;AAPJ;;AAWA;EACE,UAAA;AARF;;AAYA;EACE,iCAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,iBAAA;EACA,sCAAA;AATF;AAWE;EACE,6CAAA;AATJ;AAYE;EACE,uCAAA;EACA,mCAAA;AAVJ;AAcE;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAZJ;;AAgBA;EACE;IACE,WAAA;IACA,eAAA;IACA,kBAAA;EAbF;AACF;AAiBA;EACE,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,iBAAA;EACA,2DAAA;AAfF;AAiBE;EACE,qDAAA;EACA,mCAAA;AAfJ;AAkBE;EACE,0CAAA;AAhBJ;AAmBE;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;AAjBJ","sourcesContent":[".primaryButton {\r\n  color: white;\r\n  border: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px 22px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n  font-size: var(--font-boton);\r\n  min-width: 120px;\r\n  position: relative;\r\n\r\n  &:hover:not(:disabled) {\r\n    transform: translateY(-1px);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #b6b6b6 !important;\r\n    cursor: not-allowed !important;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.primary {\r\n  background-color: var(--color-primario);\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: var(--color-primario-dark);\r\n  }\r\n}\r\n\r\n.secondPrimary {\r\n  color: var(--color-primario-dark);\r\n  font-size: var(--font-boton);\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  background-color: var(--color-primario-claro-200);\r\n  border: 1px solid var(--color-primario-claro);\r\n  padding: 5px 22px;\r\n  transition: background-color 0.2s ease;\r\n\r\n  &.active {\r\n    background-color: var(--color-primario-claro);\r\n  }\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: var(--color-primario-claro);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #e0e0e0;\r\n    color: #888;\r\n    border-color: #d0d0d0;\r\n    cursor: not-allowed !important;\r\n  }\r\n}\r\n\r\n.spinner {\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 2px solid rgba(255, 255, 255, 0.4);\r\n  border-top-color: white;\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading {\r\n  pointer-events: none;\r\n  opacity: 0.8;\r\n  transform: none;\r\n\r\n\r\n  .spinner {\r\n    position: absolute;\r\n  }\r\n}\r\n\r\n.contentHidden {\r\n  opacity: 0;\r\n}\r\n\r\n\r\n.cancel {\r\n  color: var(--color-cancelar-dark);\r\n  font-size: var(--font-boton);\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  background-color: var(--color-cancelar-claro);\r\n  border: 1px solid var(--color-cancelar);\r\n  padding: 5px 22px;\r\n  transition: background-color 0.2s ease;\r\n\r\n  &.active {\r\n    background-color: var(--color-cancelar-claro);\r\n  }\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: var(--color-cancelar);\r\n    transform: translateY(0) !important;\r\n  }\r\n\r\n\r\n  &:disabled {\r\n    background-color: #e0e0e0;\r\n    color: #888;\r\n    border-color: #d0d0d0;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .primaryButton {\r\n    width: 100%;\r\n    min-width: auto;\r\n    padding: 10px 16px;\r\n  }\r\n}\r\n\r\n\r\n.danger {\r\n  color: white;\r\n  font-size: var(--font-boton);\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  background-color: var(--color-danger);\r\n  border: 1px solid var(--color-danger-dark);\r\n  padding: 5px 22px;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: var(--color-danger-dark) !important;\r\n    transform: translateY(0) !important;\r\n  }\r\n\r\n  &.active {\r\n    background-color: var(--color-danger-dark);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #e0e0e0;\r\n    color: #888;\r\n    border-color: #d0d0d0;\r\n    cursor: not-allowed !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryButton": `PrimaryButton_primaryButton__g83qt`,
	"primary": `PrimaryButton_primary__sfZbk`,
	"secondPrimary": `PrimaryButton_secondPrimary__dlsOi`,
	"active": `PrimaryButton_active__US9aI`,
	"spinner": `PrimaryButton_spinner__iQeBY`,
	"spin": `PrimaryButton_spin__PpNHN`,
	"loading": `PrimaryButton_loading__d8ZQq`,
	"contentHidden": `PrimaryButton_contentHidden__SBrp6`,
	"cancel": `PrimaryButton_cancel__RhE8X`,
	"danger": `PrimaryButton_danger__gj81g`
};
export default ___CSS_LOADER_EXPORT___;
